import analyticsManager from './core';

// Main analytics interface - simplified to only what's actually used
export const analytics = {
  // Initialize analytics
  init: () => analyticsManager.init(),
  
  // Track generic event - this is what sendAnalytics uses
  track: (eventName, properties) => analyticsManager.track(eventName, properties),
};

// Backward compatibility with existing sendAnalytics function
export const sendAnalytics = (eventName, payload = {}, language = 'en') => {
  analytics.track(eventName, {
    ...payload,
    page_language: language,
  });
};
